import { gql } from '@apollo/client';

import { type IEscrowInvitation } from 'src/graphql/schema';
import { EscrowInvitationFields } from 'src/graphql/actions/escrow/escrowInvitation.fragment';

import { apolloCache as cache } from '../apollo-client';

export const addEscrowInvitationCache = (invitation: IEscrowInvitation) => {
  const escrowType = '__typename' in invitation.escrow ? invitation.escrow.__typename : '';
  const escrowId = invitation.escrow.id;

  cache.writeFragment({
    id: `${escrowType}:${escrowId}`,
    fragment: gql`
      fragment AddEscrowInvitation on ${escrowType} {
        escrowInvitation {
          ...EscrowInvitationFields
        }
      }
      ${EscrowInvitationFields}
    `,
    fragmentName: 'AddEscrowInvitation',
    data: {
      escrowInvitation: invitation,
    },
  });
};
